/**
 * YulOnTap — shared phone normalization (frontend mirror of backend services/phone_utils.py).
 *
 * Accepts user-entered phones in common formats and returns E.164 ("+15145551234").
 * Returns null when the input can't be reasonably normalized.
 *
 * Rules:
 *   - Leading "+" preserved, digit-only stripped; 8-15 digits → valid.
 *   - 10 digits → assume North America, prefix "+1".
 *   - 11 digits starting with "1" → prefix "+".
 *   - 11-15 digits otherwise → prefix "+" (assume country code included).
 */
export function normalizePhoneE164(raw) {
    if (raw === null || raw === undefined) return null;
    const s = String(raw).trim();
    if (!s) return null;

    if (s.startsWith('+')) {
        const compact = '+' + s.slice(1).replace(/\D+/g, '');
        const digits = compact.slice(1);
        if (digits.length >= 8 && digits.length <= 15) return compact;
        return null;
    }

    const digits = s.replace(/\D+/g, '');
    if (!digits) return null;
    if (digits.length === 10) return '+1' + digits;
    if (digits.length === 11 && digits.startsWith('1')) return '+' + digits;
    if (digits.length >= 11 && digits.length <= 15) return '+' + digits;
    return null;
}

/** Normalize + de-dupe a list of raw phones. Accepts strings or {phone_number|phone} dicts. */
export function normalizePhoneList(list) {
    const out = [];
    const seen = new Set();
    for (const item of list || []) {
        const raw = typeof item === 'object' && item !== null
            ? (item.phone_number ?? item.phone)
            : item;
        const norm = normalizePhoneE164(raw);
        if (norm && !seen.has(norm)) {
            seen.add(norm);
            out.push(norm);
        }
    }
    return out;
}
